import { Component, OnInit } from '@angular/core';
import { EXCHANGE_RATES } from 'src/app/onelog/common/config/url';
import { RequestService } from 'src/app/onelog/services/request.service';

@Component({
  selector: 'app-exchange-rates',
  templateUrl: './exchange-rates.component.html',
  styleUrls: ['./exchange-rates.component.css'],
})
export class ExchangeRatesComponent implements OnInit {
  constructor(private _requestService: RequestService) {}

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  responseData: any = [];

  ngOnInit(): void {
    this.loadProducts();
  }

  loadProducts(postData: any = [], url: string = EXCHANGE_RATES) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = this.responseData.data;
        this.totalProducts = this.responseData.total;
        this.perPage = this.responseData.per_page;
        this.lastPage = this.responseData.last_page;
        this.currentPage = this.responseData.current_page;
        console.log(data);
      });
  }

  downloadReport() {
    this._requestService.download(
      EXCHANGE_RATES,
      {
        is_download: 1,
      },
      '',
      'Exchange_Rates'
    );
  }

  currencySymb: any = {
    MXN: '$',
    THB: '\u0e3f',
    CAD: '$',
    AUD: '$',
    EUR: '\u20ac',
    INR: '\u20b9',
    PLN: 'z\u0142',
    SGD: '$',
    KRW: '\u20a9',
    USD: '$',
    PHP: '\u20b1',
    BRL: 'R$',
    GBP: '\u00a3',
    CNY: '\u00a5',
    NZD: '$',
    JPY: '\u00a5',
    null: '',
  };

  getCurrencySymb(key: string): string {
    return this.currencySymb[key] || key;
  }
}
